import { render, staticRenderFns } from "./question-comment.vue?vue&type=template&id=0c35788c&"
import script from "./question-comment.vue?vue&type=script&lang=ts&"
export * from "./question-comment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c35788c')) {
      api.createRecord('0c35788c', component.options)
    } else {
      api.reload('0c35788c', component.options)
    }
    module.hot.accept("./question-comment.vue?vue&type=template&id=0c35788c&", function () {
      api.rerender('0c35788c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/question-comment.vue"
export default component.exports